import {useFormContext, useWatch} from 'react-hook-form';
import {FormTypes} from '../../utils/guestForm';
import {useSchema} from 'context/guest';
import {useEffect} from 'react';
import {GUEST_FORM_NAMES} from '@chekin/core';

function useValidatePreloadedFields() {
  const {setValue} = useFormContext<FormTypes>();
  const documentType = useWatch()[GUEST_FORM_NAMES.document_type];
  const {formFields} = useSchema();

  useEffect(
    function validPreloadedDocumentType() {
      if (documentType && formFields[GUEST_FORM_NAMES.document_type]?.options?.length) {
        const availableOptions = formFields[GUEST_FORM_NAMES.document_type]?.options;
        const existingOption = availableOptions?.find(
          option => option.value === documentType.value,
        );

        if (!existingOption) {
          setValue(GUEST_FORM_NAMES.document_type, undefined);
        }
      }
    },
    [formFields, documentType, setValue],
  );
}

export {useValidatePreloadedFields};
